module.exports = __webpack_public_path__ + "img/indisch_monument_beeld_600x600px.d5efa656.png";